// src/components/PeoplePlan/TheBench/components/WorkflowControls/WorkflowControls.js
import React from "react";
import ViewToggleButton from "./ViewToggleButton";
import StatusFilters from "./StatusFilters";
import KanbanFilters from "./KanbanFilters";
import "./WorkflowControls.css";

const WorkflowControls = ({
  viewMode,
  onViewToggle,
  loading,
  employees,
  kanbanFilters,
  onKanbanFilterChange,
  onResetKanbanFilters,
  getUniqueValues,
  selectedStatuses,
  onStatusChange,
  onRefresh,
  isIntegrated = false,
  userRole
}) => {
  return (
    <div className={`bench-controls-bar ${isIntegrated ? 'integrated' : ''}`}>
      <div className="bench-controls-content">
        {/* Only show view toggle button when NOT integrated */}
        {!isIntegrated && (
          <ViewToggleButton 
            viewMode={viewMode} 
            onToggle={onViewToggle} 
          />
        )}

        {/* Show filters when integrated or in kanban view */}
        {(isIntegrated || viewMode === "kanban") && !loading && employees.length > 0 && (
          <KanbanFilters
            filters={kanbanFilters}
            onFilterChange={onKanbanFilterChange}
            onReset={onResetKanbanFilters}
            getUniqueValues={getUniqueValues}
            selectedStatuses={selectedStatuses}
            onStatusChange={onStatusChange}
            isIntegrated={isIntegrated}
          />
        )}

        {/* Show loading/no data message */}
        {(isIntegrated || viewMode === "kanban") && (loading || employees.length === 0) && (
          <div className="bench-filters-section">
            <p style={{ color: "#666", fontStyle: "italic", margin: 0 }}>
              {loading ? "Loading filters..." : "No data available for filters"}
            </p>
          </div>
        )}

        {/* Only show status checkboxes when NOT integrated */}
        {!isIntegrated && viewMode === "table" && (
          <StatusFilters
            selectedStatuses={selectedStatuses}
            onStatusChange={onStatusChange}
          />
        )}
      </div>
    </div>
  );
};

export default WorkflowControls;